import { gql } from '@apollo/client';
import { ClientCartonListResult } from '../types/ClientCartonTypes';

export const GET_CLIENT_CARTONS = gql`
    query GetClientCartons(
        $bigBagNo: String
        $masterWaybillNo: String
        $channelId: Long
        $scanStatus: Int
        $arrivePortCode: String
        $scanWarehouseId: Long
        $hubFilterWarehouseId: Long
        $createdAtFrom: String
        $createdAtTo: String
        $scanTimeFrom: String
        $scanTimeTo: String
        $pageRequest: PageRequestTypeInput
    ) {
        getClientCartons(
            bigBagNo: $bigBagNo
            masterWaybillNo: $masterWaybillNo
            channelId: $channelId
            scanStatus: $scanStatus
            arrivePortCode: $arrivePortCode
            scanWarehouseId: $scanWarehouseId
            hubFilterWarehouseId: $hubFilterWarehouseId
            createdAtFrom: $createdAtFrom
            createdAtTo: $createdAtTo
            scanTimeFrom: $scanTimeFrom
            scanTimeTo: $scanTimeTo
            pageRequest: $pageRequest
        ) {
            items {
                id
                bigBagNo
                masterWaybillNo
                channelName
                arrivePortCode
                presortCode
                scanStatus
                scanType
                scanPort
                parcelCount
                onlineParcelCount
                offlineParcelCount
                createdAt
                scanTime
            }
            totalCount
        }
    }
`;

export const GET_CLIENT_CARTON_ARRIVE_PORT_CODES = gql`
    query GetClientCartonArrivePortCodes {
        getClientCartonArrivePortCodes
    }
`;

export interface GetClientCartonsResponse {
    getClientCartons: ClientCartonListResult;
}

export interface GetClientCartonArrivePortCodesResponse {
    getClientCartonArrivePortCodes: string[];
}

export interface PageRequestTypeInput {
    page: number;
    size: number;
    sortBy?: string;
    sortDirection?: 'ASC' | 'DESC';
}

export interface GetClientCartonsVariables {
    bigBagNo?: string;
    masterWaybillNo?: string;
    channelId?: number;
    scanStatus?: number;
    arrivePortCode?: string;
    scanWarehouseId?: number;
    hubFilterWarehouseId?: number;
    createdAtFrom?: string;
    createdAtTo?: string;
    scanTimeFrom?: string;
    scanTimeTo?: string;
    pageRequest?: PageRequestTypeInput;
}
